import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Signin } from './signin/signin.model';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { AuthResponse } from './auth.response';
import { map, timeout, catchError } from 'rxjs/operators';
import { SessionService } from 'src/app/shared/services/sessionStorage.service';
import { User } from 'src/app/_core/models/user';
import { UtilitiesService } from 'src/app/_core/services/utilities.service';


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseUrl = 'https://fichepresence.oneci.ci/api/api-fiche-presence/'; 
  user: any;
  currentUser: any;
  userConnect: any;
  showModal: boolean = false;
  isLogin: boolean = false;
  private currentUserSubject: BehaviorSubject<User | null>;

  constructor(
    private httpClient: HttpClient,
    private sessionStorage: SessionService,
    private utilities:  UtilitiesService
  ) {
    const rawData = this.sessionStorage.get('currentUser');
  // console.log('Raw data from sessionStorage:', rawData);
  
  // Try to initialize with proper parsing
  let parsedUser = null;
  if (rawData) {
    try {
      parsedUser = JSON.parse(rawData);
      // console.log('Parsed user data:', parsedUser);
    } catch (e) {
      console.error('Failed to parse user data:', e);
    }
  }
  
  this.currentUserSubject = new BehaviorSubject<User| null>(parsedUser);;
  // console.log('BehaviorSubject initial value:', this.currentUserSubject.value);
  this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User | null {
    return this.currentUserSubject.value;
  }

  private makeRequest<T>(
    method: string,
    endpoint: string,
    body?: any,
    params?: any
  ): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    console.log("url pour connect ", url);
    
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${this.user?.token || ''}`
    );

    switch (method) {
      case 'GET':
        return this.httpClient
          .get<T>(url, { params, headers })
          .pipe(timeout(3 * 60 * 1000), this.errorHandler());
      case 'POST':
        return this.httpClient
          .post<T>(url, body, { headers })
          .pipe(timeout(3 * 60 * 1000), this.errorHandler());
      case 'PUT':
        return this.httpClient
          .put<T>(url, body, { headers })
          .pipe(timeout(3 * 60 * 1000), this.errorHandler());
      default:
        throw new Error('Invalid HTTP method');
    }
  }

  private errorHandler() {
    return catchError((error) => {
      console.error('API Error:', error);
      return of(null as any);
    });
  }

  signIn(data: Signin): Observable<AuthResponse> {
    return this.makeRequest<AuthResponse>('POST', 'users/connexion', data);
  }

login(email: string, password: string) {
  const request = {
    data: {
      email,
      password,
    },
  };

  console.log('Login request:', request);

  return this.makeRequest<any>('POST', 'users/connexion', request).pipe(
    map((response: any) => {
      console.log('Server response:', response);
      
      if (response && !response.hasError) {
        let userData = null;
        
        if (response.item) {
          userData = response.item;
          this.utilities.showNotification("Operation effectué avec succès", 'success')
        } else if (response.items && response.items.length > 0) {
          userData = response.items[0];
        } else if (response.itemsUtilisateur && response.itemsUtilisateur.length > 0) {
          userData = response.itemsUtilisateur[0];
        }
        
        if (userData) {
          console.log('User data found:', userData);
          
          if (!userData.email && email) {
            userData.email = email;
          }
          
          this.sessionStorage.put('currentUser', userData);
          
          const storedData = this.sessionStorage.get('currentUser');
          console.log('Stored data verification:', storedData);
          
          try {
            const parsedData = typeof storedData === 'string' ? JSON.parse(storedData) : storedData;
            console.log('Parsed stored data:', parsedData);
            
            this.currentUserSubject.next(parsedData);
          } catch (e) {
            console.error('Error parsing stored data:', e);
          }
          
          this.isLogin = true;
        } else {
          console.warn('No user data found in response');
        }
      }
      
      return response;
    })
  );
}

resendOtp(email: string) {
  const request = {
    data: {
      email,
    },
  };

  console.log('Resend OTP request:', request);

  return this.makeRequest<any>('POST', 'users/regenerateOtp', request).pipe(
    map((response: any) => {
      console.log('Resend OTP response:', response);
      return response;
    })
  );
}


forgetMdp(email: string) {
  const request = {
    data: {
      email,
    },
  };

  return this.makeRequest<any>('POST', 'users/resetAccount', request).pipe(
    map((response: any) => {
      return response;
    })
  );
}
  
 
  isAuthenticated(): boolean {
    const currentUser = sessionStorage.getItem('currentUser');

    if (currentUser && currentUser.trim() !== '') {
      try {
        const parsedUser = JSON.parse(currentUser);
        return this.isTokenValid(parsedUser);
      } catch (error) {
        return false;
      }
    }

    return false;
  }

  getCurrentUserEmail(): string {
    const userJson = sessionStorage.getItem('currentUser');
    return userJson ? JSON.parse(userJson).email : '';
  }

  changePassWord(email: string, password: string, oldMotDePasse: string) {
    const request = {
      data: {
        oldMotDePasse,
        password,
        email,
      },
    };

    return this.makeRequest<any>(
      'POST',
      'users/changerMotDePasse',
      request
    ).pipe(
      map((user: any) => {
        if (user?.item?.length > 0) {
          if (user.item.isDefaultPassword == false) {
            this.showModal;
          }
          const userData = user.item[0];
          
this.sessionStorage.put('currentUser', JSON.stringify(userData));
          this.currentUserSubject.next(userData);
        }
        return user;
      })
    );
  }

changeMotDePasse(email: string, password: string, codeOtp: string) {
  const request = {
    data: {
      codeOtp,
      password,
      email,
    },
  };

  return this.makeRequest<any>(
    'POST',
    'users/validateOtpAndResetPassword',
    request
  ).pipe(
    map((user: any) => {
      if (user?.item?.length > 0) {
        if (user.item.isDefaultPassword == false) {
          this.showModal;
        }
        const userData = user.item[0];
        
this.sessionStorage.put('currentUser', JSON.stringify(userData));
        this.currentUserSubject.next(userData);
      }
      return user;
    })
  );
}


  private isTokenValid(user: any): boolean {
    if (user && user.token) {
      const expirationTime = user.tokenExpiration;
      if (expirationTime) {
        return new Date(expirationTime) > new Date();
      }

      return !!user.token;
    }

    return false;
  }

  setCurrentUser(userData: any) {
    
this.sessionStorage.put('currentUser', JSON.stringify(userData));
  }

  otp(codeOtp: string, email: string) {
    if (!email) {
      const storedUser = this.sessionStorage.get('currentUser');
      if (storedUser) {
        try {
          const userData = typeof storedUser === 'string' ? JSON.parse(storedUser) : storedUser;
          email = userData.email || '';
          console.log('Recovered email from storage:', email);
        } catch (e) {
          console.error('Error parsing stored user data:', e);
        }
      }
    }
  
    const request = {
      data: {
        codeOtp,
        email
      },
    };
  
    console.log('OTP validation request:', request);
  
    return this.makeRequest<any>('POST', 'users/validateOtpCode', request).pipe(
      map((response: any) => {
        console.log('OTP validation response:', response);
        
        // Structure de réponse adaptée à votre API
        if (response && !response.hasError && response.item) {
          const userData = response.item;
          console.log('User data after OTP validation:', userData);
          
          this.sessionStorage.put('currentUser', userData);
          
          const storedData = this.sessionStorage.get('currentUser');
          console.log('Data stored after OTP validation:', storedData);
          
          this.currentUserSubject.next(userData);
          console.log('BehaviorSubject updated after OTP:', this.currentUserSubject.value);
          
          if (userData.token) {
            this.sessionStorage.put('authToken', userData.token);
          }
          
          this.isLogin = true;
        } else {
          console.warn('Invalid response or error in OTP validation');
        }
        
        return response;
      })
    );
  }

 
logout(): Observable<boolean> {
  localStorage.clear();
  this.sessionStorage.remove('authToken')
  this.sessionStorage.remove('currentUser'); 
  this.currentUserSubject.next(null);
  this.isLogin = false;
  return of(true);
}

 
}
